import React from "react";

function CreditCard() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="20"
      viewBox="0 0 20 16"
    >
      <path
        fill="#4d5153"
        d="M20 4H4a1.985 1.985 0 00-1.99 2L2 18a1.993 1.993 0 002 2h16a1.993 1.993 0 002-2V6a1.993 1.993 0 00-2-2zm-1 14H5a1 1 0 01-1-1v-5h16v5a1 1 0 01-1 1zm1-10H4V6h16z"
        data-name="Path 3011"
        transform="translate(-2 -4)"
      ></path>
    </svg>
  );
}

export default CreditCard;
